import React, { useEffect, useState } from "react";
import { Table, Button, Image, Space, Typography, Card } from "antd";
import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import { AiFillDelete, AiTwotoneEdit } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import deleteDataById from "../../../hooks/admin/deleteDataById";
import LoadingSpinner from "../../../components/utils/LoadingSpinner";

const { Title } = Typography;

const ManageLanguage = () => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [languages, setLanguages] = useState([]);
  const user = JSON.parse(localStorage.getItem("admin"));

  useEffect(() => {
    setLoading(true);
    const getLanguages = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_APIURL}/admin/getalllanguage`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${user.token}`,
            },
          }
        );
        const response = await res.json();
        if (response?.data) {
          setLanguages(response.data);
        }
      } catch (error) {
        toast.error("Failed to load languages.");
      } finally {
        setLoading(false);
      }
    };

    getLanguages();
  }, []);

  const deleteItem = async (id) => {
    confirmAlert({
      title: `${t("delete_alert_title")}`,
      message: `${t("delete_alert_des")}`,
      buttons: [
        {
          label: `${t("Yes")}`,
          onClick: async () => {
            setLoading(true);
            const res = await deleteDataById("admin/deletelanguage", id);
            if (res.status_code === 200) {
              setLanguages((prev) =>
                prev.filter((item) => item.language_id !== id)
              );
              toast.success(`${t("data_deleted_successfully")}`);
            } else {
              toast.error("Failed to delete.");
            }
            setLoading(false);
          },
        },
        {
          label: `${t("No")}`,
          onClick: () => { },
        },
      ],
    });
  };

  const columns = [
    {
      title: t("Flags"),
      dataIndex: "image",
      key: "image",
      render: (image) => <Image src={image} width={50} height={35} />,
    },
    {
      title: t("Short_name"),
      dataIndex: "language_short_name",
      key: "language_short_name",
    },
    {
      title: t("Full_Name"),
      dataIndex: "language_full_name",
      key: "language_full_name",
    },
    {
      title: t("Options"),
      key: "actions",
      render: (_, record) => (
        <Space>
          <Link
            to={`/admin/language/edit/${record.language_id}`}
            title={t("Edit")}
          >
            <Button
              icon={<AiTwotoneEdit />}
              type="default"
              shape="circle"
              className="border-green-600 text-green-600 hover:bg-green-600 hover:text-white"
            />
          </Link>

          <Button
            icon={<AiFillDelete />}
            danger
            shape="circle"
            title={t("Delete")}
            onClick={() => deleteItem(record.language_id)}
          />
        </Space>
      ),
    },
  ];

  if (loading) return <LoadingSpinner />;

  return (
    <>
      <Helmet>
        <title>{t("Admin")} - {t("All_Languages")}</title>
      </Helmet>

      <div className="flex justify-between items-center mb-4">
        <Title level={4}>{t("All_Languages")}</Title>
        <Link to="/admin/language/create">
          <button className="btn btn-primary btn-sm text-white">{t("Create_Language")}</button>
        </Link>
      </div>
      <Table
        columns={columns}
        dataSource={languages}
        rowKey="language_id"
        bordered
        pagination={{ pageSize: 10 }}
      />
    </>
  );
};

export default ManageLanguage;
